import { render } from "./AboutUsComponent.vue?vue&type=template&id=61b6326d"
import script from "./AboutUsComponent.vue?vue&type=script&lang=js"
export * from "./AboutUsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__